export default __webpack_public_path__ + "static/media/clap.f2f128ba.svg";